import "./NavBar.css";
import { Container, Navbar, Form, FormControl, Row, Col, Nav, Button, InputGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

import Cart_Image from "../assets/cart-59-256.png";

const NavBar = (props) => {
  const { user, handleLogout } = props;
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const [result, setResult] = useState([]);
  const [isToggled, setToggle] = useState(false);

  const getCartCount = () => {
    return cartItems.reduce((qty, item) => Number(item.qty) + qty, 0);
  };

  const toggleScroll = () => {
    setToggle(!isToggled);
    if(!isToggled){
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    }
    else{
      document.getElementsByTagName('body')[0].style.overflow = 'visible';
    }
  }

  const handleOnSearch = async (string, results) => {
    await fetch(`/search?term=${string}`, { method: 'POST' })
      .then(res => res.json())
      .then(data => setResult(data))
  }

  const handleOnSelect = (item) => {
    window.location.replace(`/product/${item._id}`);
  }

  const handleOnFocus = () => {
    console.log('Focused')
  }

 
  return (
    <div>
      {!user ? (
        <Container className="navbar-container">
          <Navbar className="navbar" expand="lg" style={{ backgroundColor: isToggled ? "#F5EFED" : "transparent" }} >
            <Navbar.Brand href="/">nothing</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleScroll} />
            <Navbar.Collapse id="basic-navbar-nav">
              <InputGroup>
                <div id='search-form'>
                  <ReactSearchAutocomplete
                    items={result}
                    onSearch={handleOnSearch}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    autoFocus
                  />
                </div>
              </InputGroup>
              <Nav.Link href="/about">about</Nav.Link>
              <Nav.Link href="/contact">contact</Nav.Link>
              <Nav.Link href="/login">login</Nav.Link>
              <Nav.Link href="/cart">
                <Row id="cart-section">
                  <Col lg="12" md="12" sm="12" xs="12"><img src={Cart_Image} id="cart-icon" /> </Col>
                  <Col lg="12" md="12" sm="12" xs="12"><span className="cartlogo-badge">{getCartCount()}</span> </Col>
                </Row>
              </Nav.Link>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      ) : (
        <Container className="navbar-container">
          <Navbar className="navbar" expand="lg" style={{ backgroundColor: isToggled ? "#F5EFED" : "transparent" }} >
            <Navbar.Brand href="/">nothing</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleScroll} />
            <Navbar.Collapse id="basic-navbar-nav">
              <InputGroup>
                <div id='search-form'>
                  <ReactSearchAutocomplete
                    items={result}
                    onSearch={handleOnSearch}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    autoFocus
                  />
                </div>
              </InputGroup>
              <Nav.Link href="/about">about</Nav.Link>
              <Nav.Link href="/contact">contact</Nav.Link>
              <Nav.Link href="/login" onClick={handleLogout}>logout</Nav.Link>
              <Nav.Link href="/cart">
                <Row id="cart-section">
                  <Col md="12" sm="12" xs="12"><img src={Cart_Image} id="cart-icon" /> </Col>
                  <Col md="12" sm="12" xs="12"><span className="cartlogo-badge">{getCartCount()}</span> </Col>
                </Row>
              </Nav.Link>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      )}

    </div>
  )
}

export default NavBar;